import type { FunctionComponent } from 'react';

import { ResizableSplitScreenManager } from './ResizableSplitScreenManager';

export const SplitScreenEntryComponent: FunctionComponent = () => {
  //this will very soon be used for drag to collapse for board, which is why
  //I am not simply deleting this component
  return <ResizableSplitScreenManager />;
};
